<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (!definition.disablePrint && definition.subType !== 'label') {
  <button mat-icon-button
    (click)="print()"
    matTooltip="Print">
    <mat-icon svgIcon="print" aria-label="Print"></mat-icon>
  </button>
}
